import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  TextField,
  Stack,
  Typography,
  Box,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { useQuery } from "@apollo/client";
//Icons
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
//Srcs
import "../../Style/dialogstyle.scss";
import EmptyImge from "../../Assets/empty-image.png";
import { SELECT_MATERIAL } from "../../Schema/Material";
import { SELECT_UNIT_BYID_MATERIAL } from "../../Schema/Reqpurchase";
import { SelectWarehouse } from "../Include/DynamicSelect";
import moment from "moment";

export default function ListReturnBookPrint({
  handleUpdateList,
  handleUpdateListSubBook,
  handleDeleteList,
  handleDeleteSubList,
  handleAddList,
  handleAddListSubBook,
  requiredField,
  bookList,
  groupId,
}) {
  const [listMaterialOptions, setMeterialOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);

  const [materialId, setMaterialId] = useState("");
  const [checkMaterial, setCheckMaterial] = useState(false);
  const [checkUnit, setCheckUnit] = useState(false);

  const { refetch } = useQuery(SELECT_MATERIAL, {
    variables: {
      isUse: true,
      groupId: groupId,
      sectionId: null,
    },
    onCompleted: ({ selectMaterial }) => {
      // console.log("selectMaterial::", selectMaterial)
      //
      if (selectMaterial?.length > 0) {
        const materialData = selectMaterial?.map((e) => {
          return {
            id: e?._id,
            title: e?.materialKhName,
            // title: "ISBN: "+e?.isbm+" - "+e?.groupId?.groupKhName,
            fullName: e?.materialKhName,
            // +" "+e?.materialKhName,
          };
        });
        setMeterialOptions(materialData);
      } else {
        setMeterialOptions([]);
      }
    },
    onError: (error) => {
      // setLoading(true);
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [checkMaterial, groupId]);

  const { refetch: refetchUnit } = useQuery(SELECT_UNIT_BYID_MATERIAL, {
    variables: {
      materialId: materialId,
    },
    onCompleted: ({ selectUnitByMaterialId }) => {
      // console.log("selectUnitByMaterialId:::", selectUnitByMaterialId);
      if (selectUnitByMaterialId?.length > 0) {
        const unitData = selectUnitByMaterialId?.map((e) => {
          return {
            id: e?._id,
            title: e?.unitId?.unitKhName,
            imageSrc: e?.imageSrc,
          };
        });
        setUnitOptions(unitData);
      } else {
        setUnitOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetchUnit();
  }, [checkUnit, materialId]);

  const handleCheckRemainQTY = (rentQty, retureArray, key) => {
    let remainQty = 0;
    if (retureArray?.length > 0) {
      let returnQty = 0;
      retureArray?.map((row) => {
        if (row?.key !== key) {
          returnQty += parseFloat(row?.qty);
        }
      });
      remainQty = rentQty - returnQty;
    } else {
      remainQty = rentQty;
    }

    console.log("remainQty:::::", remainQty);
    return remainQty;
  };

  // console.log("requiredField:::", requiredField)

  const handleTranslateText = (val) => {
    if (val === "same") {
      return "ដូចដើម";
    }
    if (val === "same") {
      return "ដូចដើម";
    }
    return val;
  };

  return (
    <Stack direction="column" spacing={1} sx={{ width: "100%" }}>
      <Stack
        direction="row"
        spacing={1}
        mb={1}
        bgcolor="#f5faff"
        paddingX="2px"
        paddingY="5px"
        borderRadius="8px"
      >
        <Typography className="field-title-list" sx={{ width: "10%" }}>
          រូបភាព
        </Typography>
        <Typography className="field-title-list" sx={{ width: "35%" }}>
          ឈ្មោះសម្ភារៈ
        </Typography>
        <Typography className="field-title-list" sx={{ width: "10%" }}>
          ឃ្លាំង
        </Typography>
        <Typography
          className="field-title-list"
          sx={{ textAlign: "center", width: "15%" }}
        >
          ចំ.ប្រគល់
        </Typography>
        <Typography
          className="field-title-list"
          sx={{ textAlign: "center", width: "15%" }}
        >
          ស្ថានភាពពេលប្រគល់
        </Typography>
        <Typography
          className="field-title-list"
          sx={{ textAlign: "center", width: "15%" }}
        >
          អ្នកប្រគល់
        </Typography>
        <Typography
          className="field-title-list"
          sx={{ textAlign: "center", width: "15%" }}
        >
          កាលបរិច្ឆេទ
        </Typography>
        <Stack width="5%" direction="column" justifyContent="center">
          <Box textAlign="center">
            {/* <IconButton onClick={handleAddList}>
              <AddCircleIcon sx={{ color: "#2e3192" }} />
            </IconButton> */}
          </Box>
        </Stack>
      </Stack>

      {bookList?.map((e) => {
        // console.log("e::::", e);

        return (
          <Stack direction="column" width="100%" spacing={-3} key={e?.key}>
            <Stack direction="row" spacing={1}>
              <Stack width="8%"></Stack>
              <Stack direction="column" justifyContent="center">
                <Typography
                  sx={{ height: "30px", color: "#2e3192", fontWeight: "bold" }}
                >
                  {e?.materialId?.fullName}
                </Typography>
              </Stack>
            </Stack>

            <Stack direction="row" width="100%" spacing={1}>
              <Stack width="10%">
                <img
                  style={{
                    borderRadius: "10px",
                    objectFit: "cover",
                    width: "80%",
                  }}
                  src={
                    e?.listMaterialUnitId?.imageSrc
                      ? e?.listMaterialUnitId?.imageSrc
                      : EmptyImge
                  }
                />
              </Stack>

              <Stack width="25%" direction="column" justifyContent="center">
                {e?.qty} {e.listMaterialUnitId?.title}
              </Stack>

              <Stack
                width="65%"
                direction="column"
                justifyContent="center"
                spacing={1}
              >
                {e?.returnMaterial?.length > 0 &&
                  e?.returnMaterial?.map((rowReturn, indexReturn) => {
                    console.log("rowReturn::::", rowReturn);
                    return (
                      <Stack
                        direction="row"
                        width="100%"
                        spacing={1}
                        key={indexReturn}
                      >
                        <Stack
                          width="20%"
                          direction="column"
                          justifyContent="center"
                        >
                          <TextField
                            size="small"
                            fullWidth
                            value={rowReturn?.warehouseId?.title}
                          />

                          {/* <SelectWarehouse
                            selectedVal={rowReturn?.warehouseId}
                            setSelectedVal={ (val) => {
                              console.log(val);
                              handleUpdateListSubBook(e?.key , rowReturn?.key , val , "warehouseId") 
                            }}                    
                            disabled={rowReturn?.isOld}
                            error={requiredField && rowReturn?.warehouseId?.id === ""}
                          />   */}
                        </Stack>

                        <Stack
                          width="15%"
                          direction="column"
                          justifyContent="center"
                        >
                          <TextField
                            size="small"
                            fullWidth
                            value={rowReturn?.qty}
                          />
                          {/* <TextField
                            className="text-field"
                            fullWidth
                            size="small"
                            type="number"
                            placeholder="បរិមាណ"
                            onFocus={(val) => val?.target?.select()}
                            value={rowReturn?.qty}
                            onChange={(val) => {
                              if( parseFloat(val.target.value) <= handleCheckRemainQTY( e?.qty , e?.returnMaterial , rowReturn?.key ) ) {
                                handleUpdateListSubBook(e.key, rowReturn?.key, val.target.value, "qty")
                              } else {
                                handleUpdateListSubBook(e.key, rowReturn?.key, handleCheckRemainQTY( e?.qty , e?.returnMaterial, rowReturn?.key) , "qty")
                              }                              
                            }}
                            error={
                              (requiredField && rowReturn?.qty === 0) ||
                              (requiredField && rowReturn?.qty === "0") ||
                              (requiredField && rowReturn?.qty < 0)
                            } 
                            inputProps={{
                              min: 0,
                            }}
                            disabled={rowReturn?.isOld}
                          /> */}
                        </Stack>

                        <Stack
                          width="20%"
                          direction="column"
                          justifyContent="center"
                        >
                          <TextField
                            size="small"
                            fullWidth
                            value={handleTranslateText(rowReturn?.condition)}
                          />
                          {/* <FormControl fullWidth size="small" className="search-field">
                            <Select
                              value={rowReturn?.condition}
                              onChange={(val) =>
                                handleUpdateListSubBook(e.key, rowReturn?.key, val.target.value, "condition")
                              }
                              disabled={rowReturn?.isOld}
                            >
                              <MenuItem value="same">ដូចដើម</MenuItem> 
                              <MenuItem value="broke">ខូច/រហែក</MenuItem>
                            </Select>
                          </FormControl> */}
                        </Stack>

                        <Stack
                          width="20%"
                          direction="column"
                          justifyContent="center"
                        >
                          <TextField
                            className="text-field"
                            fullWidth
                            size="small"
                            placeholder=""
                            value={rowReturn?.returnBy}
                          />
                        </Stack>

                        <Stack
                          width="20%"
                          direction="column"
                          justifyContent="center"
                        >
                          <TextField
                            className="text-field"
                            fullWidth
                            size="small"
                            placeholder=""
                            value={moment(rowReturn?.returnDate)?.format(
                              "DD-MM-YYYY",
                            )}
                          />
                        </Stack>

                        <Stack
                          width="5%"
                          direction="column"
                          justifyContent="center"
                        >
                          {rowReturn?.isOld === false && (
                            <IconButton
                              sx={{ width: "40px", height: "40px" }}
                              onClick={() =>
                                handleDeleteSubList(e.key, rowReturn?.key)
                              }
                            >
                              <RemoveCircleIcon sx={{ color: "red" }} />
                            </IconButton>
                          )}
                        </Stack>
                      </Stack>
                    );
                  })}
              </Stack>
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
}
